import React from 'react';
import NavBar from '../components/Navbar/NavBar';
import PetugasKeamananIcon from '../images/petugas-keamanan.svg'
import PendidikanPelatihan from '../images/pendidikan-pelatihan.svg'
import Peralatan from '../images/peralatan.svg'
import K9Unit from '../images/k9-unit.svg'
import MonitoringControlling from '../images/monitoring-controlling.svg'
import Layanan1 from '../images/layanan-1.png'
import SectionHeading from './SectionHeading';

const serviceList = [
    {
        icon: PetugasKeamananIcon,
        title: 'Petugas Keamanan',
        description:
            'Menghadirkan para personil security yang terseleksi dengan baik melalui tahapan yang telah ditetapkan oleh Mabes Polri serta standar perusahaan.',
    },
    {
        icon: PendidikanPelatihan,
        title: 'Pendidikan & Pelatihan',
        description:
            'Pendidikan dan pelatihan para personil security mengacu kepada kurikulum yang ditetapkan oleh Mabes Polri baik pelatihan dasar ataupun latihan lanjutan. Para personil security juga akan mendapatkan pelatihan khusus berdasarkan kebutuhan project.',
    },
    {
        icon: Peralatan,
        title: 'Peralatan (Equipment)',
        description:
            'Demi menunjang serta memaksimalkan pelaksanaan tugas di lapangan, penggunaan peralatan seperti CCTV, Fire Alarm, dan Panic Button akan lebih memberikan hasil maksimal dalam pelaksanaan tugas keamanan.',
    },
    {
        icon: K9Unit,
        title: 'K9 - Unit (K9-Team)',
        description: 'Dengan dilengkapi unit satwa yang terlatih maka sistem pengamanan akan lebih maksimal.',
    },
    {
        icon: MonitoringControlling,
        title: 'Monitoring & Controlling',
        description:
            'Dengan melibatkan unsur TNI dan POLRI sebagai tenaga pendukung, baik dalam sistem pengawasan dan pengendalian anggota maupun sebagai fungsi-fungsi lain, guna menjamin keamanan aset-aset perusahaan serta jaminan situasi area kerja yang aman dan kondusif.',
    },
];

const Services = () => {
    return (
        <div id="services" className="bg-gray-50 pt-24 pb-8">
            <NavBar />

            <div className="container-app py-8">
                <SectionHeading eyebrow="Layanan Kami" title="Layanan" />
            </div>

            <div className="flex flex-col">
                {serviceList.map(({ icon, title, description }, index) => {
                    const reversed = index % 2 === 1;
                    return (
                        <section
                            key={title}
                            className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}
                            data-aos="fade-up"
                        >
                            <div className="container-app py-10 md:py-12">
                                <div
                                    className={`flex flex-col items-center gap-8 lg:gap-16 ${
                                        reversed ? 'lg:flex-row-reverse' : 'lg:flex-row'
                                    }`}
                                >
                                    <div className="card w-full max-w-[489px] h-[240px] md:h-[286px] overflow-hidden flex items-center justify-center shrink-0">
                                        <img
                                            src={Layanan1}
                                            alt={title}
                                            className="w-full h-auto object-cover"
                                        />
                                    </div>

                                    <div className="flex flex-col w-full max-w-[540px] text-center lg:text-left items-center lg:items-start">
                                        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-brand/10 mb-4">
                                            <img alt="" className="w-6 h-6 object-contain" src={icon} />
                                        </div>
                                        <h3 className="font-semibold text-xl text-slate-900 mb-3">{title}</h3>
                                        <p className="text-slate-600 leading-relaxed">{description}</p>
                                    </div>
                                </div>
                            </div>
                        </section>
                    );
                })}
            </div>
        </div>
    );
}

export default Services;
